import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { Select } from '../../../../../../design/inputs/select/Select';
import { timeZones } from '../../../../../models/timeZones/timeZones.model';

interface IProps {
  selectedTimeZone: number;
  onTimeZoneChanged(timeZone: number): void;
}

export const UpdateWorkspaceTimeZoneForm = observer((props: IProps): ReactElement => {
  return (
    <Select
      onChange={(_, v) => {
        props.onTimeZoneChanged(v.value ?? timeZones[0].value);
      }}
      value={timeZones.find((x) => x.value === props.selectedTimeZone)}
      options={timeZones}
    />
  );
});
